
































import Component from 'vue-class-component'
import Vue from 'vue'
import HttpError from '@/shared/components/http-error.vue'
import { HttpResponse } from '@/shared/utils/http'
import { Injector } from '@/config/dependency-injection'
import { ProjectModule } from '@/business/project/store/project-module'
import { ProjectViewModel } from '@/business/project/interfaces/project-view-model'
import { Prop } from 'vue-property-decorator'
import RespondecoLoadingIndicator from '@/shared/components/respondeco-loading-indicator.vue'
import { LoaderHelper } from '@/shared/services/loader-helper'
import { CLEAR_PROJECT, FETCH_PROJECT } from '@/business/project/store/types'
import RespondecoEditItemBar from '@/main/respondeco-edit-item-bar.vue'
import { imageUrl } from '@/shared/utils/images'
import RespondecoHeaderImage from '@/shared/components/respondeco-header-image.vue'
import { OrganisationLite } from '@/business/organisation/interfaces/organisation-lite'
import ProjectHeader from '@/business/project/components/project-header.vue'
import RespondecoContactAuthor from '@/shared/components/respondeco-contact-author.vue'
import RespondecoAuthorSection from '@/shared/components/respondeco-author-section.vue'
import ProjectDescription from '@/business/project/components/project-description.vue'
import ProjectPartners from '@/business/project/components/project-partners.vue'
import UnifyHero from '@/shared/components/unify/unify-hero.vue'
import UnifyBlock from '@/shared/components/unify/unify-block.vue'
import ProjectHeaderImage from '@/business/project/components/project-header-image.vue'
import RespondecoGallery from '@/shared/components/respondeco-gallery.vue'
import RespondecoGalleryItem from '@/shared/components/respondeco-gallery-item.vue'
import ProjectGallery from '@/business/project/components/project-gallery.vue'
import ProjectLearnings from '@/business/project/components/project-learnings.vue'
import { MetaService } from '@/shared/services/meta-service'
import { Hooks } from '@/shared/interfaces/hooks'
import ProjectPosts from '@/business/project/components/project-posts.vue'
import { userIsAuthenticated } from '@/shared/utils/user'
import { environmentConfiguration } from '@/config/environments'

@Component({
  name: 'project-page',
  components: {
    ProjectPosts,
    ProjectLearnings,
    ProjectGallery,
    RespondecoGalleryItem,
    RespondecoGallery,
    ProjectHeaderImage,
    UnifyBlock,
    UnifyHero,
    ProjectPartners,
    ProjectDescription,
    RespondecoAuthorSection,
    RespondecoContactAuthor,
    ProjectHeader,
    RespondecoHeaderImage,
    RespondecoEditItemBar,
    RespondecoLoadingIndicator,
    HttpError,
  },
})
export default class ProjectPage extends Vue implements Hooks {
  @Prop({
    required: true,
    type: Number,
  })
  public readonly id!: number

  public branding = environmentConfiguration().branding
  public error: HttpResponse<any> | null = null
  public imageUrl = imageUrl

  private loaderHelper = Injector.get(LoaderHelper)
  private metaService = Injector.get(MetaService)
  private projectModule = Injector.get(ProjectModule)

  public get loading(): boolean {
    return this.loaderHelper.isLoading(FETCH_PROJECT)
  }

  public get organisation(): OrganisationLite {
    return this.project.organisation
  }

  public get project(): ProjectViewModel {
    return this.projectModule.data.project
  }

  public get userIsAuthenticated(): boolean {
    return userIsAuthenticated()
  }

  public destroyed() {
    this.projectModule[CLEAR_PROJECT]()
  }

  public mounted() {
    this.projectModule.fetchProject(Number(this.id)).then(project => {
      this.metaService.updateDocumentTitle('project', {
        name: project.name,
      })
    })
  }
}
